<a-loader *ngIf="error === undefined; else errorMessage"></a-loader>
    <ng-template #errorMessage>
      <a-bad-request [message]="error.message"></a-bad-request>
    </ng-template>
  